<template>
  <simple-bar
    data-simplebar-auto-hide="false"
    class="vgp_scroll_bar_container"
    :style="height ? { height: height } : {}"
    @scroll="onScroll"
  >
    <slot />
  </simple-bar>
</template>

<script>
import SimpleBar from 'simplebar-vue';

export default {
  name: 'VgpScrollBar',
  components: {
    SimpleBar,
  },
  props: {
    height: {
      type: [String, Number],
      default: null,
    },
  },
  emits: [
    'onScroll',
  ],
  data() {
    return {
    };
  },
  methods: {
    onScroll(event) {
      this.$emit('onScroll', event);
    },
  },
};

</script>

<style lang="less" scoped>
.vgp_scroll_bar_container {
  :deep(.simplebar-vertical) {
    width: 8px;
  }

  :deep(.simplebar-mask) {
    z-index: unset;
  }
}
</style>
